import { Component, OnDestroy, OnInit } from '@angular/core';
import { FieldType, FormlyModule } from '@ngx-formly/core';
import { Subscription } from 'rxjs';
import { DynamicFormService } from '../../dynamic-form/dynamic-form.service';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { ICONS } from '../../../../_helpers/icons.constants';

@Component({
    selector: 'formly-receipt-input',
    templateUrl: "./formly-receipt.component.html",
    standalone: true,
    imports: [CommonModule, ReactiveFormsModule, FormlyModule, TranslateModule]
})
export class FormlyReceiptInputComponent extends FieldType implements OnInit, OnDestroy {

  isFormSubmitted: boolean = false;
  formSubmissionSubscription: Subscription;
  fieldKey: string;
  public ICONS = ICONS;
  constructor(private dynamicFormService: DynamicFormService) {
    super();
  }

  ngOnInit() {
    if (this.field.key) {
      this.fieldKey =this.field.id??this.field.key.toString();
    }
    this.formSubmissionSubscription = this.dynamicFormService.getFormSubmittedEvent().subscribe(data => {
      this.isFormSubmitted = data;
    });
  }

  ngOnDestroy() {
    if (this.formSubmissionSubscription) {
      this.formSubmissionSubscription.unsubscribe();
    }
  }

  getReceipt($event) {
    if (this.to.onClick && this.to.options[0].isClick) {
      this.to.onClick(this.field, $event);
    }
  }

}